<template>
  <v-row >
    <v-col cols="12" lg="3" class="d-flex flex-column">
   
    </v-col>
   
  </v-row>
</template>

<script>
//import CardWidget from "@/components/CardWidget.vue";
export default {
  name: "DealerSummaryReport",
  components: {
   // CardWidget,
  },
  data() {
    return {
      summaryReport: {
   
      },
    };
  },

  methods: {

    async getSummaryReport() {
      await this.$pds
        .get("/pds?status=FOR_CONFIRMATION&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.forConfirmationTotal = this.kFormatter(data.totalCount);
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });
      await this.$pds
        .get("/pds?status=INTERESTED&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.interestedTotal = this.kFormatter(data.totalCount);
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      await this.$pds
        .get("/pds?status=NOT_INTERESTED&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.notInterestedTotal = this.kFormatter(data.totalCount);
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      await this.$pds
        .get("/pds?status=UNCONTACTABLE&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.uncontactableTotal = this.kFormatter(data.totalCount);
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      console.log(this.summaryReport);
      this.$store.dispatch("addTicketSummaryReport", this.summaryReport);
    },

    formatNum(num = 0) {
      if (num > 0) {
        return num.toLocaleString();
      }

      return 0;
    },
     kFormatter(num) {
    return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
}
  },

  mounted() {
    this.getSummaryReport();
  },
  computed: {
    // userRole() {
    //   return this.$store.getters.userRole;
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
